<template>
  <section class="mt-12 container grid grid-cols-12 gap-4 pb-6">
    <div class="col-span-12 xl:col-span-2">
      <cart-progress :current-step="currentStep" @change-step="currentStep=$event"></cart-progress>
    </div>
    <div class="col-span-12 lg:col-span-6 xl:col-span-6">
      <section class="bg-white rounded-lg p-6 shadow-light-2">
        <BillingAddressForm v-if="currentStep === 1"
                            @address-updated="nextStep"
        />
        <CartShippingForm v-else-if="currentStep === 2 && cart.hasShipping" @address-updated="nextStep" />
        <CartPaymentForm v-else-if="currentStep === 3 || (currentStep === 2 && !cart.hasShipping)" />
      </section>
    </div>
    <div class="col-span-12 lg:col-span-6 xl:col-span-4">
      <cart-mini-cart :current-step="currentStep"/>
    </div>
  </section>
  <!--    <main>-->
  <!--        <section class="flex flex-col lg:flex-row lg:min-h-screen">-->
  <!--            <section class="w-full lg:w-1/2 xl:w-3/5 max-w-screen-xl">-->
  <!--                <cart-shipping-form-->
  <!--                        class="pt-16 border-b border-blue-700 max-w-screen-lg mx-auto"-->
  <!--                        v-if="myCart.hasShipping"-->
  <!--                        @cart-updated="updateCart"-->
  <!--                        @edit-shipping="myCart.needsShipping = true;"-->
  <!--                />-->
  <!--                <billing-address-form-->
  <!--                        class="max-w-screen-lg mx-auto mt-4"-->
  <!--                        v-if="myUser.needsAddress"-->
  <!--                        :cart="myCart"-->
  <!--                        :user="myUser"-->
  <!--                        @user-updated="updateUser"-->
  <!--                />-->
  <!--                <cart-payment-form v-else class="max-w-screen-lg mx-auto mt-8"-->
  <!--                />-->
  <!--            </section>-->
  <!--            <section class="w-full lg:w-1/2 xl:w-2/5 pl-12 pr-12 pt-16 max-w-screen-sm">-->
  <!--                <cart-mini-cart />-->
  <!--            </section>-->
  <!--        </section>-->
  <!--    </main>-->
</template>

<script>
import CartShippingForm from "./CartShippingForm";
import CartMiniCart from "./CartMiniCart";
import BillingAddressForm from "./BillingAddressForm";
import CartPaymentForm from "./CartPaymentForm";
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('cart');

export default {
  name: "CartCheckout",
  components: {CartPaymentForm, BillingAddressForm, CartMiniCart, CartShippingForm},
  props: {
    cart: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },

  created() {
    this.setCart(this.cart);
    this.setUser(this.user);
  },

  data() {
    return {
      currentStep: 1
    }
  },

  computed: {
    ...mapState({
      myCart: state => state.cart,
      myUser: state => state.user
    })
  },
  methods: {
    ...mapActions(['setCart', 'setUser']),

    nextStep() {
      this.currentStep += 1;
    },

    updateCart(event) {
      this.myCart = event;
    },

    async updateUser(event) {
      this.myUser = event;
      const response = await axios.put(`/api/cart/${this.myCart.cartId}/tax`);
      this.myCart = response.data;
    }
  }
}
</script>

<style scoped>

</style>